import UserProfileComponent from './UserProfileComponent';
import TemporaryPasswordForm from './Forms/TemporaryPasswordForm';
import ActiveGroupsForm from './Forms/ActiveGroupsForm';
import DisableLoginForm from './Forms/DisableLoginForm';
import SendWelcomeForm from './Forms/SendWelcomeForm';
import SendPasswordResetForm from './Forms/SendPasswordResetForm';
import SendAppLinkForm from './Forms/SendAppLinkForm';
import HistoryForm from './Forms/HistoryForm';

export default class AdvancedTools extends UserProfileComponent {
    templateId() {
        return '#advancedToolsTemplate';
    }

    load(containerId) {
        $(containerId).unbind('load.rendered').on('load.rendered', $.proxy(function () {
            this.bindSetTemporaryPassword(containerId);
            this.bindActiveGroups(containerId);
            this.bindDisableLogin(containerId);
            this.bindSendWelcomeMessage(containerId);
            this.bindSendPasswordReset(containerId);
            this.bindSendAppLink(containerId);
            this.bindHistory(containerId);
        }, this));
        super.load(containerId);
    }

    data() {
        return '/dashboard/profile/ajax/getAdvancedTools';
    }

    bindSendPasswordReset(containerId) {
        var form = new SendPasswordResetForm(this.loader);
        this.bindItem(containerId, form, '.sendPasswordReset');
    }

    bindSendWelcomeMessage(containerId) {
        var form = new SendWelcomeForm(this.loader);
        this.bindItem(containerId, form, '.sendWelcomeMessage');
    }

    bindSendAppLink(containerId) {
        var form = new SendAppLinkForm(this.loader);
        this.bindItem(containerId, form, '.sendAppLink');
    }

    bindSetTemporaryPassword(containerId) {
        var form = new TemporaryPasswordForm(this.loader);
        this.bindItem(containerId, form, '.setTemporaryPassword');
    }

    bindDisableLogin(containerId) {
        var form = new DisableLoginForm(this.loader);
        this.bindItem(containerId, form, '.disableLogin');
    }

    bindActiveGroups(containerId) {
        var form = new ActiveGroupsForm(this.loader);
        this.bindItem(containerId, form, '.activeGroups');
    }

    bindHistory(containerId) {
        var form = new HistoryForm(this.loader);
        this.bindItem(containerId, form, '.history');
    }

    bindItem(containerId, form, className) {
        $(containerId + ' ' + className).unbind('click').click($.proxy(function () {
            $('#advancedTools').click(); // close the menu
            form.load(this.modalContainer(), containerId);
            return false;
        }, this));
    }
}
